import { createBrowserHistory } from 'history';

// Export history to context providers to enable routing capabilities across apps/sagas
export const history = createBrowserHistory();
